import React          from 'react';
import handleNavigate from 'functions/handleNavigate';
import { makeStyles } from "makeStyles";

const useStyles = makeStyles()(
    (Theme) => ({
    root: {
        position:       'fixed',
        top:            '50%' ,
        left:           '50%',
        transform:      'translate(-50%, -50%)',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        flexFlow:       'column',
        borderRadius:   '0.5em',
        transition:     'all 0.5s',
        background:     '#FFF',
        height:         280,
        width:          500,
        zIndex:         9999
    },
    buttonContainer: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
    },
    end: {
        color:          Theme.blue,
        paddingBottom:  40,
        fontSize:       29
    },
    button: {
        height:          45,
        width:           200,
        fontWeight:      'bold',
        marginLeft:      5,
        marginRight:     5,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: Theme.darkBlue,
        color:           '#FFF',
        cursor:          'pointer',
        '&:hover': {
            backgroundColor: Theme.blue
        }
    }
    
}))

type TextProps = {
    showOptionMenu: boolean;
    reset:          () => void;
}

const Text: React.FC<TextProps> = ({ 
    showOptionMenu,
    reset
 }) => {

 const { classes } = useStyles();

 const [initialPos, setInitialPos] = React.useState(false)
 const [pos, setPos]               = React.useState(false)

 React.useEffect(() => {
    if (showOptionMenu && !initialPos) {
        setInitialPos(true)
        setTimeout(()=>{ setPos(true) },3000)
    }
    if (!showOptionMenu && initialPos) {
        setInitialPos(false)
        setPos(false)
    }
 },[showOptionMenu, initialPos])



  return (
        <div 
          className = { classes.root }
          style     = {{
              opacity:   pos ? 1 : 0,
              marginTop: pos ? 0 : '150vh' 
          }}
        >
             <div className = { classes.end }>
                 סוף
             </div>
             <div className = { classes.buttonContainer }>
                <div 
                    dir       = 'rtl'
                    className = { classes.button }
                    onClick   = { reset }
                >
                    שחקו משחק נוסף
                </div>
                <div 
                    dir       = 'rtl'
                    className = { classes.button }
                    onClick   = { () => handleNavigate('home') }
                >
                    חזרו אל עמוד הבית
                </div>
             </div>
        </div>
  );
}



export default Text;








